const TRUTHY_VALUES = new Set(['1', 'true', 'yes', 'on']);

declare global {
  // Allows specific Jest suites to force-enable MFA enforcement.
  var __ENABLE_MFA_ENFORCEMENT_IN_TESTS__: boolean | undefined;
}

const isJestRuntime = (): boolean => typeof (globalThis as { jest?: unknown }).jest !== 'undefined';

const resolveEnvFlag = (): boolean => {
  try {
    const vite = (import.meta as unknown as { env?: { VITE_DISABLE_MFA_ENFORCEMENT?: string } })
      .env;
    const proc = (
      globalThis as unknown as { process?: { env?: Record<string, string | undefined> } }
    ).process?.env;
    const raw = (
      vite?.['VITE_DISABLE_MFA_ENFORCEMENT'] ||
      proc?.['VITE_DISABLE_MFA_ENFORCEMENT'] ||
      ''
    ).trim();
    return raw !== '' && TRUTHY_VALUES.has(raw.toLowerCase());
  } catch {
    return false;
  }
};

export const isMfaHardEnforcementDisabled = (): boolean => {
  if (globalThis.__ENABLE_MFA_ENFORCEMENT_IN_TESTS__ === true) {
    return false;
  }

  if (isJestRuntime()) {
    return true;
  }

  return resolveEnvFlag();
};
